var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.dialogVisible,
      width: 600
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("div", {
    staticClass: "titleBox"
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle"
    }
  }), _vm.type == 1 ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("无法禁用")))]), _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("该附加险正在以下主险产品方案中使用，禁用"))), _c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v(_vm._s(_vm.$t("附加险将同步取消所有附加险关联")))]), _vm._v("，" + _vm._s(_vm.$t("是否继续操作")) + "？")]), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("示例:产品名称/方案名称")))])]), _c("div", {
    staticClass: "listBox",
    staticStyle: {
      "margin-top": "5px"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };